import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { RequestService } from 'src/app/services/requestService/request.service';

@Component({
  selector: 'app-input-dialog',
  templateUrl: './input-dialog.component.html',
  styleUrls: ['./input-dialog.component.less']
})
export class InputDialogComponent implements OnInit {
  inputValue;
  dialogGroup: FormGroup;
  hasError;
  //@Output() onSubmit: EventEmitter<any> = new EventEmitter<any>();
  @Output() onSubmit = new EventEmitter();
  constructor(private formBuilder: FormBuilder, public dialogRef: MatDialogRef<InputDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private requestService: RequestService) { }

  ngOnInit(): void {
    let validators = new Array();

    if (this.data?.rules?.required) {
      validators.push(Validators.required);
    }

    if (this.data?.rules?.regex) {
      validators.push(Validators.pattern(this.data.rules.regex))
    }

    this.dialogGroup = this.formBuilder.group({
      inputValue: [this.data?.value, validators]
    });

    // Error listener
    this.requestService.onInvalidPin.subscribe(resp => {
      this.hasError = "error_wrong_pin";
    });
  }


  /** Close / Confirm dialog */
  confirm() {
    let returnValues;
    if (this.data.toggle) {
      returnValues = {
        value: this.dialogGroup.controls.inputValue.value,
        toogle: this.data.toggle.value
      };
    } else {
      returnValues = {
        value: this.dialogGroup.controls.inputValue.value
      }
    }

    if (this.data.returnType == "afterClosed") {
      this.dialogRef.close(returnValues);
    } else if (this.data.returnType == "onSubmit") {
      this.onSubmit.emit(returnValues);
    }
  };

  /** Function triggered when user toogle slider  */
  onChange(event) {
    this.data.toggle.value = event.checked;

    if (event.checked) {
      this.dialogGroup.controls.inputValue.clearValidators();
      this.dialogGroup.controls.inputValue.setValidators([Validators.required, Validators.pattern(this.data.rules.regex)]);
      this.dialogGroup.controls.inputValue.updateValueAndValidity();
    } else {
      this.dialogGroup.controls.inputValue.clearValidators();
      this.dialogGroup.controls.inputValue.updateValueAndValidity();
    }
  }
}